import { Button, Stack, TextField } from "@mui/material"
import { FlightplanType } from "../../store/types/FlightPlansTypes"
import { MissionUtils } from "../../utils/MissionUtils"

const manageFlightplansMaxWidth = 460

interface IMultipleFlightPlanSelector {
    selectedPlans: FlightplanType[] //selected plans
    manageFlightPlans?: () => void
}

export const MultipleFlightPlanSelector = ({ selectedPlans, manageFlightPlans }: IMultipleFlightPlanSelector) => {
    const options = MissionUtils.transformFlightPlansToOptions(selectedPlans)
    return (
        <Stack gap={2} maxWidth={manageFlightplansMaxWidth}>
            {options.map((plan, index) => (
                <TextField
                    fullWidth={true}
                    variant="outlined"
                    label={`Flight Plan ${plan.id}`}
                    key={`flight_plan_${index}`}
                    value={plan.flightplan_name}
                    disabled
                />
            ))}
            {manageFlightPlans && (
                <Button variant="contained" color="primary" size="large" onClick={manageFlightPlans}>
                    Manage Flight Plans
                </Button>
            )}
        </Stack>
    )
}
